import * as Yup from "yup";
import { validationMessages } from "../../../../../constants/validation";
import { OpretFirmaStep1Formik } from "../../opretFirmaInterface";
const { required, validEmail } = validationMessages;
export const step2Validation = (step1Values: OpretFirmaStep1Formik) =>
  Yup.object().shape({
    email: Yup.string().email(validEmail),
    emailNotification: Yup.string().email(validEmail),
    phone: Yup.string(),
    website: Yup.string(),
    fakturaAfsend: Yup.string().required(required),
    ean: Yup.string()
      .matches(/^[0-9]{13}$/, "EAN-nummer skal altid være 13 cifre")
      .when("fakturaAfsend", {
        is: "Ean",
        then: (schema) =>
          schema.matches(
            /^[0-9]{13}$/,
            "EAN-nummer skal altid være 13 cifre",
          ) && schema.required(validationMessages.required),
        otherwise: (schema) => schema.notRequired(),
      }),
    emailFaktura: Yup.string()
      .email(validEmail)
      .when("fakturaAfsend", {
        is: "Email",
        then: (schema) =>
          schema
            .required(validationMessages.required)
            .email(validationMessages.validEmail),
        otherwise: (schema) =>
          schema.notRequired().email(validationMessages.validEmail),
      }),
    selskabstype: Yup.string().test(
      "conditional-required",
      required,
      function (value) {
        if (step1Values.inCVR !== "no") return true;
        const virksomhedsformValid = step1Values.virksomhedsform
          ? [
              "Aktieselskab",
              "KommanditaktieselskabPartnerselskab",
              "Anpartsselskab",
            ].includes(step1Values.virksomhedsform)
          : true;
        return (
          !virksomhedsformValid ||
          (virksomhedsformValid && value !== "" && value !== undefined)
        );
      },
    ),
  });
